import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import ContentSection from '../../components/UI/ContentSection'
import PageTitle from '../../components/UI/PageTitle'
import SettingsTabs from '../../components/Tabs/SettingsTabs'
import UserSettings from '../../components/Settings/User/UserSettings'
import CompanySettings from '../../components/Settings/Company/CompanySettings'

const Settings = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const isSubPath = pathname.includes('change-password')
  const isAdmin = pathname.startsWith('/admin')

  useEffect(() => {
    document.title = `${t('settings')} - ReportAll`
  }, [t])

  return (
    <ContentSection>
      {isSubPath ? (
        <Outlet />
      ) : (
        <>
          <PageTitle title={t('settings')} />
          <div className='mt-11 flex flex-col gap-11'>
            {isAdmin && (
              <SettingsTabs>
                {(activeTab) => (
                  <>
                    {activeTab === 0 && <UserSettings />}
                    {activeTab === 1 && <CompanySettings />}
                  </>
                )}
              </SettingsTabs>
            )}
            {!isAdmin && (
              <div className='bg-white flex flex-col gap-11 shadow-form max-w-6xl p-5 md:px-7 lg:p-12 rounded-20px'>
                <UserSettings />
              </div>
            )}
          </div>
        </>
      )}
    </ContentSection>
  )
}

export default Settings
